import { Node, mergeAttributes, Extension } from '@tiptap/core';
import store from '@/store/index.js';

const ShiftEnter = Extension.create({
	name: 'shiftEnter',

	addAttributes() {
		return {
			blockId: {
				isFake: false,
				default: ''
			}
		};
	},

	addCommands() {
		return {
			breakBlock: function(e) {
				console.log(e);
			}
		};
	},

	addKeyboardShortcuts() {
		return {
			Backspace: e => {
				if (this.options.isFake) {
					return;
				}
				let len = e.editor.view.state.doc.content.size;
				let anchor = e.editor.view.state.selection.anchor;

				if (len <= 2) {
					store.dispatch('block/removeTextBlock', this.options.blockId);
					return true;
				}

				if (anchor <= 1 && e.editor.view.state.selection.empty) {
					store.dispatch(
						'block/setPreviousTextBlockFocus',
						this.options.blockId
					);
					return true;
				}

				return false;
			},
			Enter: e => {
				if (this.options.isFake) {
					return false;
				}
				let len = e.editor.view.state.doc.content.size;
				let anchor = e.editor.view.state.selection.anchor;
				let size = e.editor.view.state.doc.content.size;
				if (anchor >= len - 1) {
					store.dispatch('block/breakTextBlock', {
						blockId: this.options.blockId,
						insertPosition: 'after',
						focus: true
					});
					return true;
				}
				if (anchor <= 1 && size >= 2) {
					store.dispatch('block/breakTextBlock', {
						blockId: this.options.blockId,
						insertPosition: 'before',
						focus: false
					});
					return true;
				}
			},
			ArrowUp: e => {
				let len = e.editor.view.state.doc.content.size;
				let anchor = e.editor.view.state.selection.anchor;
				// if at the beginning of line, set focus to previous block
				if (anchor <= 1) {
					store.dispatch(
						'block/setPreviousTextBlockFocus',
						this.options.blockId
					);
					return true;
				}
			},
			ArrowLeft: e => {
				let len = e.editor.view.state.doc.content.size;
				let anchor = e.editor.view.state.selection.anchor;
				// if at the beginning of line, set focus to previous block
				if (anchor <= 1) {
					store.dispatch(
						'block/setPreviousTextBlockFocus',
						this.options.blockId
					);
					return true;
				}
			},

			ArrowDown: e => {
				let len = e.editor.view.state.doc.content.size;
				let anchor = e.editor.view.state.selection.anchor;
				// check if anchor is at the end of text
				if (anchor >= len - 1) {
					store.dispatch('block/setNextTextBlockFocus', this.options.blockId);
					return true;
				}
			},
			ArrowRight: e => {
				let len = e.editor.view.state.doc.content.size;
				let anchor = e.editor.view.state.selection.anchor;
				// check if anchor is at the end of text
				if (anchor >= len - 1) {
					store.dispatch('block/setNextTextBlockFocus', this.options.blockId);
					return true;
				}
			}

			// 'Shift-Enter': e => {
			// 	//console.log(e);
			// 	return false;
			// 	// if (this.options.isFake) {
			// 	// 	return false;
			// 	// }
			// 	// let len = e.editor.view.state.doc.content.size;
			// 	// let anchor = e.editor.view.state.selection.anchor;
			// 	// // check if anchor is at the end of text
			// 	// if (anchor === len - 1) {
			// 	// 	store.dispatch('block/breakTextBlock', this.options.blockId);
			// 	// }
			// 	// return true;
			// }
		};
	}
});

export default ShiftEnter;

// export const Mention =
// 	Node.create <
// 	MentionOptions >
// 	{
// 		name: 'mention',

// 		defaultOptions: {
// 			HTMLAttributes: {},
// 			suggestion: {
// 				char: '@',
// 				command: ({ editor, range, props }) => {
// 					editor
// 						.chain()
// 						.focus()
// 						.insertContentAt(range, [
// 							{
// 								type: 'mention',
// 								attrs: props
// 							},
// 							{
// 								type: 'text',
// 								text: ' '
// 							}
// 						])
// 						.run();
// 				},
// 				allow: ({ editor, range }) => {
// 					return editor.can().insertContentAt(range, { type: 'mention' });
// 				}
// 			}
// 		},

// 		group: 'inline',

// 		inline: true,

// 		selectable: false,

// 		atom: true,

// 		addAttributes() {
// 			return {
// 				id: {
// 					default: null,
// 					parseHTML: element => {
// 						return {
// 							id: element.getAttribute('data-mention')
// 						};
// 					},
// 					renderHTML: attributes => {
// 						if (!attributes.id) {
// 							return {};
// 						}

// 						return {
// 							'data-mention': attributes.id
// 						};
// 					}
// 				}
// 			};
// 		},

// 		parseHTML() {
// 			return [
// 				{
// 					tag: 'span[data-mention]'
// 				}
// 			];
// 		},

// 		renderHTML({ node, HTMLAttributes }) {
// 			return [
// 				'span',
// 				mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
// 				`${this.options.suggestion.char}${node.attrs.id}`
// 			];
// 		},

// 		renderText({ node }) {
// 			return `${this.options.suggestion.char}${node.attrs.id}`;
// 		},

// 		addKeyboardShortcuts() {
// 			return {
// 				Backspace: () =>
// 					this.editor.commands.command(({ tr, state }) => {
// 						let isMention = false;
// 						const { selection } = state;
// 						const { empty, anchor } = selection;

// 						if (!empty) {
// 							return false;
// 						}

// 						state.doc.nodesBetween(anchor - 1, anchor, (node, pos) => {
// 							if (node.type.name === this.name) {
// 								isMention = true;
// 								tr.insertText(
// 									this.options.suggestion.char || '',
// 									pos,
// 									pos + node.nodeSize
// 								);

// 								return false;
// 							}
// 						});

// 						return isMention;
// 					})
// 			};
// 		},

// 		addProseMirrorPlugins() {
// 			return [
// 				Suggestion({
// 					editor: this.editor,
// 					...this.options.suggestion
// 				})
// 			];
// 		}
// 	};
